export const DATA_METRICS = 'data_metrics'
export const DIALER_METRICS = 'dialer_metrics'
export const CAMPAIGN_METRICS = 'campaign_metrics'
export const LIST_METRICS = 'list_metrics'
export const GATEWAY_METRICS = 'gateway_metrics'
export const REP_METRICS = 'rep_metrics'
export const REP_STACK_METRICS = 'rep_stack_metrics'
export const REP_TREND_METRICS = 'rep_trend_metrics'
